<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 00em;">I would like to acknowledge the team at Austin Macauley Publishers.</p><br/>
<p style="text-indent: 00em;">I would like to thank my family for being so encouraging always and my good friends:</p><br/>
<p style="text-indent: 00em; text-align: center;">Annette, Eileen, Dawn, Claire and Mel… and many more… you know who you are.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?f697d51e